export const editAllowed = (istAdmin, istErsteller) => istAdmin || istErsteller;
export const pinAndFokusthemaSetzenAllowed = (istAdmin, istModerator) => istAdmin || istModerator;
export const deleteAllowed = (istAdmin, istModerator, istErsteller) => istAdmin || istModerator || istErsteller;
